module.exports = __webpack_public_path__ + "static/7-ee08247774dd095379a8dcc60ccebb3f.png";